import React from 'react';
interface SectionHeadingProps {
  eyebrow?: string;
  children: React.ReactNode;
  className?: string;
}
export function SectionHeading({
  eyebrow,
  children,
  className = ''
}: SectionHeadingProps) {
  return <div className={`text-center ${className}`} data-id="element-198" data-mp="3f25d782xuqm9">
      {eyebrow && <p className="mb-3 text-xs font-semibold uppercase tracking-[0.25em] text-[var(--gold)]" data-id="element-199" data-mp="3jzncs7v2fthl">
          {eyebrow}
        </p>}
      <h2 className="font-serif-display text-3xl font-bold leading-tight text-[var(--cream)] sm:text-4xl md:text-5xl" data-id="element-200" data-mp="blolhjj1gwaf">
        {children}
      </h2>
    </div>;
}